// @ts-nocheck
//stateless functional component
import React from "react";
import {Link} from 'react-router-dom'
import propTypes from "prop-types";

const UserItem = ({ user: { avatar_url, login, html_url } }) => {
  return (
    <div className="card text-center">
      <img
        src={avatar_url}
        alt=""
        className="round-img"
        style={{ width: "60px" }}
      />
      <h3>{login}</h3>
      <div>
        <Link to={`/user/${login}`} className="btn btn-dark btn-sm my-1">
          more
        </Link>
      </div>
    </div>
  );
};
UserItem.propTypes = {
  user: propTypes.object.isRequired,
};
export default UserItem;
